export const screenBreakpoint = 576;

export const headerHeight = { mobile: 40, web: 64 };
export const breadcrumbHeight = { mobile: 38, web: 38 };
export const siderWidth = { mobile: 0, web: 200 };
